import {
    ADMIN_GROUPS
} from "../app";

import { START_LOADING, STOP_LOADING, RESET_LOADING } from "openstack-uicore-foundation/lib/utils/actions";
import { LOGOUT_USER, RECEIVE_USER_INFO } from 'openstack-uicore-foundation/lib/security/actions';

import {
    RECEIVE_SUMMITS,
    RECEIVE_SUMMIT,
    REQUEST_BADGE_FEATURES,
    RECEIVE_BADGE_FEATURES,
    SET_ACCESS_TOKEN_QS,
    GET_EXTRA_QUESTIONS,
    RECEIVE_MARKETING_SETTINGS
} from "../actions/base-actions";

import {
    REQUEST_BADGE,
    BADGE_RECEIVED,
    CLEAR_BADGE
} from "../actions/badge-actions";

import {
    RECEIVE_TICKET,
    REQUEST_TICKETS,
    RECEIVE_TICKETS,
    SET_SELECTED_TICKET,
    CLEAR_SELECTED_TICKET,
    TICKET_UPDATED
} from "../actions/ticket-actions";

import { setCSSVars } from "../utils/methods";

const DEFAULT_STATE = {
    summits: [],
    allTickets: [],
    searchTerm: null,
    summit: null,
    extraQuestions: [],
    badge: null,
    badgeViewType: null,
    accessTokenQS: null,
    loading: false,
    selectedTicket: null,
    userIsAdmin: false,
    marketingSettings: null,
};

const baseReducer = (state = DEFAULT_STATE, action) => {
    const { type, payload } = action

    switch(type){
        case RECEIVE_USER_INFO: {
            const { response } = payload;
            const userGroups = response.groups.map((group) => group.title);
            const userIsAdmin = userGroups.some(v => ADMIN_GROUPS.includes(v));
            return { ...state, userIsAdmin };
        }
        case LOGOUT_USER:
            return DEFAULT_STATE;
        case SET_ACCESS_TOKEN_QS:
            return { ...state, accessTokenQS: payload.accessToken };
        case RESET_LOADING:
            return { ...state, loading: 0 };
        case START_LOADING:
            return { ...state, loading: true };
        case STOP_LOADING:
            return { ...state, loading: false };
        case RECEIVE_SUMMITS:
            return { ...state, summits: payload, summit: null };
        case RECEIVE_SUMMIT:
            return { ...state, summit: payload.response };
        case RECEIVE_BADGE_FEATURES:
            return {
                ...state,
                summit: {
                    ...state.summit,
                    badge_features_types: payload
                }
            };
        case RECEIVE_TICKET:
            return { ...state, selectedTicket: payload.response };
        case REQUEST_TICKETS:
            return {
                ...state,
                searchTerm: payload?.searchTerm ?? null
            };
        case RECEIVE_TICKETS:
            const uniqueNewTickets = payload.filter(
                newTicket => !state.allTickets.some(existingTicket => existingTicket.id === newTicket.id)
            );
            return { ...state, allTickets: [...state.allTickets, ...uniqueNewTickets] };
        case REQUEST_BADGE:
            const { viewType } = payload;
            return { ...state, badgeViewType: viewType };
        case BADGE_RECEIVED:
            const badge = { ...payload.response };
            return { ...state, badge };
        case CLEAR_BADGE:
            return {
                ...state,
                selectedTicket: null,
                badge: null,
                badgeViewType: null,
                searchTerm: null,
                allTickets: []
            };
        case SET_SELECTED_TICKET:
            return { ...state, selectedTicket: payload };
        case TICKET_UPDATED:
            return { ...state };
        case CLEAR_SELECTED_TICKET:
            return {
                ...state,
                selectedTicket: null,
                badge: null,
                searchTerm: null,
                allTickets: []
            }
        case GET_EXTRA_QUESTIONS: {
              const extraQuestions = payload || [];
              return { ...state, loading: false, extraQuestions: extraQuestions }
        }
        case RECEIVE_MARKETING_SETTINGS: {
            const marketingSettings = payload;
            setCSSVars(marketingSettings);
            return { ...state, marketingSettings }
        }
        default:
            return state;
    }
}

export default baseReducer;
